var styles = {"box":"CheckBox_box_lnnul_1","label":"CheckBox_label_lnnul_7","v2":"CheckBox_v2_lnnul_81","invalid":"CheckBox_invalid_lnnul_113"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
